import { apiFetch } from "../http";
const buildYearQuery = (year) => {
    const normalizedYear = String(year !== null && year !== void 0 ? year : "").trim();
    if (!normalizedYear || normalizedYear === "Всего")
        return "";
    return `?year=${encodeURIComponent(normalizedYear)}`;
};
export async function getUserMoves(params) {
    const query = buildYearQuery(params.year);
    const data = await apiFetch(`/travel/api/get_user_moves/${query}`, {
        baseUrl: params.baseUrl,
        token: params.token,
        method: "GET"
    });
    if (!data.success) {
        throw new Error(data.error || "Failed to load moves");
    }
    return data.moves || [];
}
export async function getUserPoints(params) {
    const yearQuery = buildYearQuery(params.year);
    const query = params.summary ? `${yearQuery}${yearQuery ? '&' : '?'}view=summary` : yearQuery;
    const data = await apiFetch(`/travel/api/get_user_points/${query}`, {
        baseUrl: params.baseUrl,
        token: params.token,
        method: "GET"
    });
    if (!data.success) {
        throw new Error(data.error || "Failed to load points");
    }
    return data.points || [];
}
export async function getUserMapYears(params) {
    const data = await apiFetch("/travel/api/get_user_map_years/", {
        baseUrl: params.baseUrl,
        token: params.token,
        method: "GET"
    });
    if (!data.success) {
        throw new Error(data.error || "Failed to load years");
    }
    return Array.isArray(data.years) ? data.years : ["Всего"];
}
